import {authStoreKey} from '@blesk-frontend/auth';
import {redirect} from '@tanstack/react-router';
import {RouterGuardOtps} from '@/libs/router';

/**
 *
 * @param context
 * @param location
 */
export const authGuard = ({location}: RouterGuardOtps) => {
  const token: string | undefined = JSON.parse(localStorage.getItem(authStoreKey) ?? '{}')?.state
    ?.token;
  if (!token) {
    throw redirect({
      to: '/auth/signin',
      search: {
        redirect: location.href,
      },
    });
  }
};
